import { universalTypeFilterId } from '../../../../../common/constants/filters';
import type { CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import type {
	FetchedSelectFilterOption,
	SelectFilterState,
} from '../../../../../common/constants/filters/select-filter/types';
import { allProductKeys, type ProductKeys } from '../../../../../common/constants/product-keys';
import { createSingleSelectFilter } from '../../../../filters/single-select-filter';

import { getAllTypeOptions, lookupOptions } from './utils';

const loadQueryParams = (queryParams: string[], config: CloudConfig) => {
	const allOptions = getAllTypeOptions(config);
	return allOptions
		.filter((option) => !option.isDefault)
		.filter((option) => queryParams.includes(option.queryParamValue))
		.map((option) => ({
			trackingKey: option.value,
			label: option.label,
			value: option.value,
			queryParamValue: option.queryParamValue,
			isDefault: option.isDefault,
			product: config.product,
		}));
};

const getInitialOptions = (config: CloudConfig) => {
	const allOptions = getAllTypeOptions(config);
	return allOptions.map((option) => ({
		trackingKey: option.value,
		label: option.label,
		value: option.value,
		queryParamValue: option.queryParamValue,
		isDefault: option.isDefault,
		product: config.product,
	}));
};

const sortCompareFn = (a: FetchedSelectFilterOption, b: FetchedSelectFilterOption) => {
	const allOption = getAllTypeOptions({ intl: undefined });
	return (
		allOption.findIndex((option) => option.queryParamValue === a.queryParamValue) -
		allOption.findIndex((option) => option.queryParamValue === b.queryParamValue)
	);
};

export const filter: Readonly<{
	id: 'universalTypeFilter';
	type: 'single-select' | 'multi-select';
	queryParams: {
		key: string;
		getState: (
			queryParams: Record<string, string[]>,
			cloudId: string,
		) => SelectFilterState<'universalTypeFilter'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (
		state: unknown,
		config: CloudConfig,
	) => import('../../../../../common/constants/filters/select-filter/types').SelectFilterMonad<'universalTypeFilter'>;
	getInitialState: (
		config: CloudConfig,
	) => import('../../../../../common/constants/filters/select-filter/types').SelectFilterMonad<'universalTypeFilter'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createSingleSelectFilter({
	id: universalTypeFilterId,
	products: allProductKeys,
	alwaysVisible: true,
	universal: true,
	queryParams: {
		key: 'type',
		fetcher: async (queryParams, config) => {
			return loadQueryParams(queryParams, config);
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			return getInitialOptions(config);
		},
	},
	lookup: {
		fetcher: async (query, config) => {
			// NOTE: this is the first step of filtering options
			//  the store does product specific filtering
			return lookupOptions(query, config);
		},
	},
	sortCompareFn,
});
